import { SearchControl } from "@wordpress/components";

export default function Sidebar(props) {
  const { searchInput, setSearchInput } = props;

  return (
    <div className="icon-inserter__sidebar">
      <div className="icon-inserter__sidebar__search">
        <SearchControl
          value={searchInput}
          onChange={setSearchInput}
          __nextHasNoMarginBottom
        />
      </div>
    </div>
  );
}
